module.exports = __webpack_public_path__ + "static/media/design-develop-first@3x.7039a021.jpg";